import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { delay } from 'rxjs/operators';
import { ConsoleEquipmentsListObject, FacilityConsoleEquipmentsObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { SelectionInfo } from '../multi-selection/multi-selection.model';

@Component({
  selector: 'app-equipment-selection',
  templateUrl: './equipment-selection.component.html',
  styleUrls: ['./equipment-selection.component.scss'],
})
export class EquipmentSelectionComponent implements OnInit, OnChanges {
  @Input() selectionInfo: SelectionInfo;
  @Input() defaultEquipment: string;  
  @Input() isReloadSelectEquipment: boolean;
  @Input() permission: string;
  @Input() isSelectedCardioConsole = false;
  @Input() isIncludedSmartStrength = false;
  @Output() onEquipmentChange: EventEmitter<string> = new EventEmitter<string>();

  private availableEquipments: ConsoleEquipmentsListObject[] = [];
  private selectedEquipment: ConsoleEquipmentsListObject | undefined;
  private showDropdown = false;

  constructor(
    private facilityService: FacilityService) {}

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // let current = changes.selectionInfo?.currentValue;
    // let previous = changes.selectionInfo?.previousValue;
    // if (current && (current.activityId != previous?.activityId ||
    //   current.consoleType != previous?.consoleType ||
    //   current.facility.facilityId != previous?.facility.facilityId)) {
    //   this.getAvailableEquipments();
    //   this.onEquipmentChange.emit(this.selectedEquipment?.activityId);
    // }
    if(changes.isReloadSelectEquipment?.currentValue) {
      this.getAvailableEquipments();
      setTimeout(() => this.onEquipmentChange.emit(this.selectedEquipment?.activityId));
    }
    if (changes.defaultEquipment?.currentValue != changes.defaultEquipment?.previousValue) {
      this.selectedEquipment = this.availableEquipments.find(e => e.activityId == changes.defaultEquipment?.currentValue);
    } 
  }

  private selectEquipment(equipment: ConsoleEquipmentsListObject): void {
    this.showDropdown = false;
    if(equipment.activityId != this.selectedEquipment?.activityId) {
      this.selectedEquipment = equipment;
      this.onEquipmentChange.emit(this.selectedEquipment.activityId);
    }
  }

  private getAvailableEquipments() {
    const consoles = this.getConsoleList();
    let selectedConsole = consoles.find((console) => console.consoleType === this.selectionInfo.consoleType);
    if (selectedConsole && selectedConsole.equipments.length > 0) {
      let equipmentList = JSON.parse(JSON.stringify(selectedConsole.equipments));
      this.checkPermissions(equipmentList);
    } else if(this.selectionInfo.consoleType === 'all'){
      let equipmentList = JSON.parse(JSON.stringify(this.selectionInfo.consoleObj.equipments));
      let allCount = 0;
      equipmentList.forEach((item: { activityId: string; count: any; }) => {
        if(item.activityId === '-1') {
          allCount += Number(item.count);
        }
      });
      let last = true;
      for (let index = 0; index < equipmentList.length; index++) {
        if(equipmentList[index].activityId === '-1') {
          if(last) {
            last = false;
            equipmentList[index].count = allCount.toString();
          } else {
            equipmentList.splice(index, 1)
          }
        }
      }
      let uniqueIds: any = [...new Set(equipmentList.map((x: { activityId: string; }) => x.activityId))];
      let equipmentListUnique: ConsoleEquipmentsListObject[] = [];
      uniqueIds?.forEach((item: string) => {
        const result = equipmentList.filter((x: ConsoleEquipmentsListObject) => x.activityId === item);
        let eqItem: ConsoleEquipmentsListObject= {activityId: item, count: '0', equipmentOrderId: ''}
        result.forEach((r: any) => {
          eqItem.count = (Number(eqItem.count) + Number(r.count)).toString();
          eqItem.equipmentOrderId = r.equipmentOrderId;
        })
        equipmentListUnique.push(eqItem);
      })
      equipmentList = equipmentListUnique;

      equipmentList.sort((a: ConsoleEquipmentsListObject, b: ConsoleEquipmentsListObject) => Number(a.equipmentOrderId) < Number(b.equipmentOrderId) ? -1 : 1);
      this.checkPermissions(equipmentList);
    }
  }

  checkPermissions(equipmentList: any) {
    if (this.permission === 'hasPerformanceRun') {
      this.availableEquipments = equipmentList.filter((equip: any) => equip.activityId === '1' || equip.activityId === '28');
    } else if (this.permission === 'hasCustomWorkouts') {
      this.availableEquipments = equipmentList.filter((equip: any) => equip.activityId !== '-1');
    } else {
      this.availableEquipments = this.setAllEquipment(equipmentList);
    }
    this.selectDefault();
  }

  private selectDefault() {
    this.selectedEquipment = undefined;
    if(!this.availableEquipments || this.availableEquipments.length < 1) return;
    this.selectedEquipment = this.availableEquipments.find(e => e.activityId == this.selectionInfo.activityId);
    if(!this.selectedEquipment) {
      this.selectedEquipment = this.availableEquipments[0];
    }
  }

  private setAllEquipment(equipments: ConsoleEquipmentsListObject[]): ConsoleEquipmentsListObject[] {
    if(equipments[0].activityId != '-1') {
      const index = equipments.findIndex((item) => item.activityId == '-1');
      if (index != -1) {
        equipments.splice(0, 0, equipments.splice(index, 1)[0]);
      }
    }    
    return equipments;
  }

  private getConsoleList() {
    let consoles: FacilityConsoleEquipmentsObject[] = [];
    this.facilityService.selectedMultiFacilities().forEach(element => {
      const fac = this.facilityService.getFacilityById(element);
      if(fac && fac.consoleEquipments) consoles = consoles.concat(...fac.consoleEquipments);
    });
    return consoles.filter((v, i, a) => a.findIndex(f => f.consoleType === v.consoleType) === i);
  }
}
